export default function header() {
	let body = document.body;
	let menu_triggers = document.querySelectorAll('.mega-menu__triggers [class*="mega-menu__"]');
	let submenus = document.querySelectorAll('.mega-menu-option');
	let search_input = document.querySelector('.site-header .wp-block-search__input');
	let search_trigger = document.querySelector('.site-header .wp-block-search__button');
	let mobile_menu_trigger = document.querySelector('#trigger-mobile-menu');

	let submenuTimeout;

	let mobile_drilldown_items = document.querySelectorAll('#mobile-menu-items .primary-menu-items [class*="trigger-"]');
	let mobile_dropdown_items = document.querySelectorAll('#mobile-menu-items .has-mobile-submenu-dropdown > a');
	let mobile_submenu_close = document.querySelectorAll('.mobile-submenu-close');

	let menu_active = false;
	let search_active = false;

	const search_max_width = () => {
		let search_trigger_pos = search_trigger.getBoundingClientRect();
		let positionLeft = search_trigger_pos.left + window.pageXOffset;
		let search_field = document.querySelector('.site-header .wp-block-search__input');

		search_field.setAttribute('style', 'max-width: ' + positionLeft + 'px;');
	};

	/**
	 * Set active menu position
	 * 
	 * @param {object} current_target
	 * @param {string} menu_item_class
	 * 
	 * @return {void}
	 */
	const set_active_menu_position = ( current_target, menu_item_class ) => {
		let menu_item = document.getElementById(menu_item_class);
		let active_menu_item = document.querySelector('.mega-menu__triggers .active');

		// Check if there is an active item
		if ( active_menu_item ) {
			active_menu_item.classList.remove('active');
			document.querySelector('.mega-menu-option.active').classList.remove('active');
		}

		current_target.classList.add('active');
		menu_item.classList.add('active');
		
		let menu_position_left = current_target.offsetLeft;
		let menu_item_width    = current_target.clientWidth;

		if ( 'mega-menu__solutions' === menu_item_class || 'mega-menu__insights' === menu_item_class ) {
			menu_item.style.left = (menu_position_left + (menu_item_width/2)) + 'px';
		} else {
			let style = document.createElement('style');

			// Add ID to style tag
			style.id = 'mega-menu-style';
			style.innerHTML = "#" + menu_item_class + ":before { left: " + ((menu_position_left + (menu_item_width/2)) - 5) + "px !important; }";

			// Add style to body
			document.body.appendChild(style);
		}
	};

	/**
	 * Reset active menu position
	 * 
	 * @return {void}
	 */
	const reset_active_menu_position = () => {
		// remove mega-menu-style style
		let mega_menu_style = document.getElementById('mega-menu-style');
		if ( mega_menu_style ) {
			mega_menu_style.remove();
		}
		
		let active_menu_item = document.querySelector('.mega-menu__triggers .active');
		let active_menu_option = document.querySelector('.mega-menu-option.active');

		if ( ! active_menu_item ) {
			return false;
		}
		
		let menu_position_left = active_menu_item.offsetLeft;
		let menu_item_width    = active_menu_item.clientWidth;

		if ( active_menu_item.classList.contains( 'mega-menu__solutions' ) || active_menu_item.classList.contains( 'mega-menu__insights' ) ) {
			active_menu_option.style.left = (menu_position_left + (menu_item_width/2)) + 'px';
		} else {
			let style = document.createElement('style');

			// Add ID to style tag
			style.id = 'mega-menu-style';
			style.innerHTML = "#" + active_menu_item.classList[0] + ":before { left: " + ((menu_position_left + (menu_item_width/2)) - 5) + "px !important; }";

			// Add style to body
			document.body.appendChild(style);
		}
	};

	const deactivate_menu = () => {
		let active_menu_item = document.querySelector('.mega-menu__triggers .active');
		let active_menu_option = document.querySelector('.mega-menu-option.active');

		if ( active_menu_item ) {
			active_menu_item.classList.remove('active');
		}

		if ( active_menu_option ) {
			active_menu_option.classList.remove('active');
		}

		if ( document.body.classList.contains('menu-open') ) {
			document.body.classList.remove('menu-open');
		}
	};

	const deactivate_search = () => {
		body.classList.remove('search-open');
	};

	/**
	 * Conditionally deactivate search or menu
	 */
	const maybe_deactivate_search_or_menu = ( triggered_el ) => {
		if ( 'search' === triggered_el && menu_active ) {
			// deactivate menu
			deactivate_menu();
			menu_active = false;
		}

		if ( 'menu' === triggered_el && search_active ) {
			// deactivate search
			deactivate_search();
			search_active = false;
		}
	};

	// Desktop Menu
	menu_triggers.forEach(menu_trigger => {
		menu_trigger.addEventListener("mouseenter", function(e) {
			let menu_item_id = e.currentTarget.classList;
			let menu_item_class = menu_item_id[0];
			let menu_item = document.getElementById(menu_item_class);
		
			clearTimeout(submenuTimeout);
			maybe_deactivate_search_or_menu( 'menu' );
		
			if (menu_item) {
				set_active_menu_position( e.currentTarget, menu_item_class );

				menu_active = true;

				document.body.classList.add('menu-open');
			}
		});

		menu_trigger.addEventListener("mouseleave", function(e) {
			submenuTimeout = setTimeout(function() {
				e.preventDefault();

				deactivate_menu();

				// remove mega-menu-style style
				let mega_menu_style = document.getElementById('mega-menu-style');
				if ( mega_menu_style ) {
					mega_menu_style.remove();
				}

				let menu_item_id = e.currentTarget.classList;
				let menu_item_class = menu_item_id[0];
				let menu_item = document.getElementById(menu_item_class);
				
				e.currentTarget.classList.remove('active');
				menu_item.classList.remove('active');

				menu_active = false;

				if ( document.body.classList.contains('menu-open') ) {
					document.body.classList.remove('menu-open');
				}
			}, 300); // Adjust the delay as needed
		});
	});
	
	submenus.forEach(function(submenu) {
		submenu.addEventListener("mouseenter", function() {
			clearTimeout(submenuTimeout);
		});
	
		submenu.addEventListener("mouseleave", function() {
			submenuTimeout = setTimeout(function() {
				deactivate_menu();
			}, 300); // Adjust the delay as needed
		});
	});

	if ( search_trigger ) {
		search_max_width();

		window.addEventListener('resize', search_max_width);

		search_input.addEventListener('keyup', (e) => {
			if ( search_input.value !== '' ) {
				search_input.classList.add('has-value');
			} else {
				search_input.classList.remove('has-value');
			}
		});

		search_trigger.addEventListener('click', (e) => {
			if ( search_input.value === '' || ! search_active ) {
				e.preventDefault();
			}

			maybe_deactivate_search_or_menu( 'search' );

			body.classList.toggle('search-open');

			if ( body.classList.contains('search-open') ) {
				search_active = true;
			} else {
				search_active = false;
			}
		});
	}

	window.addEventListener("resize", reset_active_menu_position);

	// Mobile Menu
	mobile_menu_trigger.addEventListener('click', (e) => {
		e.preventDefault();

		body.classList.toggle('mobile-menu-open');
	});

	mobile_drilldown_items.forEach(drilldown_item => {
		drilldown_item.addEventListener('click', (e) => {
			let drilldown_submenu = e.currentTarget.classList;
			drilldown_submenu = drilldown_submenu[0].replace('trigger-', 'submenu-');
		
			let submenu = document.getElementById(drilldown_submenu);
		
			submenu.classList.add('active');
		});
	});

	mobile_submenu_close.forEach(submenu_close => {
		submenu_close.addEventListener('click', (e) => {
			e.preventDefault();
			let el = e.currentTarget;

			el.closest('.is-mobile-submenu').classList.remove('active');
		});
	});

	mobile_dropdown_items.forEach(dropdown_item => {
		dropdown_item.addEventListener('click', (e) => {
			e.preventDefault();
			let el = e.currentTarget.closest('.has-mobile-submenu-dropdown');

			el.classList.toggle('active');
		});
	});
}